import { AttachmentFileType } from '../types/AttachmentFile';
export default function createLocalComputerFiles(fileList) {
    if (!fileList) {
        return null;
    }
    var localFiles = [];
    for (var i = 0; i < fileList.length; i++) {
        var file = fileList[i];
        var localFile = {
            fileType: AttachmentFileType.Local,
            name: file.name,
            size: file.size,
            type: file.type,
            fileObject: file,
        };
        localFiles.push(localFile);
    }
    return localFiles;
}
//# sourceMappingURL=createLocalComputerFiles.js.map